module.exports = __webpack_public_path__ + "img/industry-banner-06.fb3fe79f.png";